import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FooterModule } from './shared/footer/footer.module';
import { SidebarModule } from './sidebar/sidebar.module';
import { LbdModule } from './lbd/lbd.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { UserComponent } from './user/user.component';
import { TablesComponent } from './tables/tables.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { NichesComponent } from './niches/niches.component';
import { QuestionsComponent } from './questions/questions.component';
import { RegularComponent } from './admin/regular/regular.component';
import { SatisfactionComponent } from './admin/satisfaction/satisfaction.component';
import { SurveyComponent } from './admin/survey/survey.component';
import { AssessmentsComponent } from './assessments/assessments.component';
import { HelpComponent } from './help/help.component';
import { ModalModule } from "ngx-bootstrap/modal"; 
// import { TabsModule } from "ngx-tabs";
import { TabsModule, TabsetConfig } from 'ngx-bootstrap/tabs';
import { NewRegularModalComponent } from './admin/new-regular-modal/new-regular-modal.component';
import { NewNicheModalComponent } from './new-niche-modal/new-niche-modal.component';
import { Globals } from "app/globals";
import { PurchaseAssessmentModalComponent } from './purchase-assessment-modal/purchase-assessment-modal.component';
import { ClientReportsComponent } from "app/client/client-reports/client-reports.component";
import { ClientAssessmentsComponent } from "app/client/client-assessments/client-assessments.component";
import { UnassignedAssessmentsComponent } from "app/coach/unassigned-assessments/unassigned-assessments.component";
import { InstructionsComponent } from './client/instructions/instructions.component';
import { AssessmentsQuestionsComponent } from './client/assessments-questions/assessments-questions.component';
import { RaterAssessmentInstructionsComponent } from './rater/rater-assessment-instructions/rater-assessment-instructions.component';
import { RaterAssessmentComponent } from './rater/rater-assessment/rater-assessment.component';
import { PendingAssessmentsComponent } from './client/pending-assessments/pending-assessments.component';
import { CompletedAssessmentsComponent } from './client/completed-assessments/completed-assessments.component';
import { RatersComponent } from './client/raters/raters.component';
import { AssignAssesmentsModalComponent } from './coach/assign-assesments-modal/assign-assesments-modal.component';
import { ClientsComponent } from './coach/clients/clients.component';
import { CoachAssessmentsComponent } from './coach/assessments/assessments.component';//
import { EmailTemplatesComponent } from './admin/email-templates/email-templates.component'; //
import { NewEmailTemplateComponent } from './admin/new-email-template/new-email-template.component';
import { PredefinedEmailTemplatesComponent } from './coach/predefined-email-templates/predefined-email-templates.component';
import { EmailTemplateComponent } from './coach/email-template/email-template.component';
import { AssessmentEliComponent } from './admin/assessment-eli/assessment-eli.component';
import { Assessment360Component } from './admin/assessment-360/assessment-360.component';
import { NewEliAssessmentComponent } from './admin/new-eli-assessment/new-eli-assessment.component';
import { New360AssessmentComponent } from './admin/new-360-assessment/new-360-assessment.component';
import { DataVisualizerComponent } from './admin/data-visualizer/data-visualizer.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { BiDashboardComponent } from './admin/bi-dashboard/bi-dashboard.component';
import { NewSatisfactionModalComponent } from "app/admin/new-satisfaction-modal/new-satisfaction-modal.component";
import { NewSurveyModalComponent } from "app/admin/new-survey-modal/new-survey-modal.component";
import { Section1Component } from './admin/section1/section1.component';
import { Section2Component } from './admin/section2/section2.component';
import { NewSection1ModalComponent } from "app/admin/new-section1-modal/new-section1-modal.component";
import { NewSection2ModalComponent } from "app/admin/new-section2-modal/new-section2-modal.component";
// import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { ChartsModule } from 'ng2-charts';
import { CustomComponent } from './coach/custom/custom.component';
import { ProfileComponent } from './coach/profile/profile.component';
import { ImageUploadModule } from "angular2-image-upload";
import { AssignedComponent } from './coach/assigned/assigned.component';
import { CoachCompletedAssessmentsComponent } from "app/coach/completed-assessments/completed-assessments.component";
import { AssignedRatersComponent } from './coach/assigned-raters/assigned-raters.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CoachDirectoryComponent } from './client/coach-directory/coach-directory.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DataVisualizerResultsComponent } from './admin/data-visualizer-results/data-visualizer-results.component';
import { EnergyLeadershipComponent } from './client/energy-leadership/energy-leadership.component';
import { AssessmentReportComponent } from './client/assessment-report/assessment-report.component';
import { CoachAssessmentReportComponent } from "app/coach/assessment-report/assessment-report.component";
import { AssessmentReport360Component } from './coach/assessment-report-360/assessment-report-360.component';
import { PipeReplaceSpaces } from "app/pipes/pipe-replace-spaces";
import { AssignAssesmentsNewModalComponent } from "app/coach/assign-assesments-new-modal/assign-assesments-new-modal.component";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AgGridModule } from 'ag-grid-angular';
import { NewRegularChoiceModalComponent } from "app/admin/new-regular-choice-modal/new-regular-choice-modal.component";
import { NewSatisfactionChoiceModalComponent } from "app/admin/new-satisfaction-choice-modal/new-satisfaction-choice-modal.component";
import { AssignedAssessmentComponent } from "app/client/assigned-assessment/assigned-assessment.component";
import { AuthGuardService } from "app/services/guard/auth-guard.service";
import { AdminGuardService } from "app/services/guard/admin-guard.service";
import { CoachGuardService } from "app/services/guard/coach-guard.service";
import { ClientGuardService } from "app/services/guard/client-guard.service";
import { RaterGuardService } from "app/services/guard/rater-guard.service";
import { AssessmentRefreshGuardService } from "app/services/guard/assessment-refresh-guard.service";
import { ClientComponent } from 'account-activation/client.component';
import { AccountActivationComponent } from 'account-activation/account-activation/account-activation.component';
import { NewEmailTemplateComponentCopy1 } from './admin/new-email-template-Copy/new-email-template.component';
import { CoachEmailsComponent } from './coach/coach-emails/coach-emails.component';
import { NewCoachEmailTemplateComponent } from './coach/new-coach-email-template/new-coach-email-template.component';
import { RaterAssessmentsComponent } from './rater/rater-assessments/rater-assessments.component';
import { AssessmentSectionsComponent } from './admin/assessment-sections/assessment-sections.component';
import { BusinessInteligenceComponent } from './admin/business-inteligence/business-inteligence.component';
import { Sections360Component } from './admin/sections360/sections360.component';
import { AssessmentComponent } from 'assessment/assessment.component';
import { KonvaModule } from 'ng2-konva';
//import { QuillModule } from 'ngx-quill';
// import { NgxGraphModule } from '@swimlane/ngx-graph';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RaterTakeAssessmentComponent } from 'rater-assessment/rater-assessment.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { CoachDashboardComponent } from './coach/coach-dashboard/coach-dashboard.component';
import { RaterTypesComponent } from './admin/rater-types/rater-types.component';
import { CRaterTypesComponent } from './coach/c-rater-types/c-rater-types.component'; 
import { CoachHomeComponent } from './coach/home/home.component'; 
import { AnnouncementsComponent } from './admin/announcements/announcements.component'; 
import { PreviousRouteService } from './services/angular/GetPreviousRoute.service';
import { AssessmentDetailsComponent } from './coach/assessmentDetails/assessmentDetails'; 
import { PopoverModule } from "ngx-smart-popover";
import { TagInputModule } from 'ngx-chips-angular';
import { ExpiredComponent } from './coach/expired/expired.component';
import { AdminService } from './services/admin/AdminService';
import { CoachService } from './services/coach/CoachService';
import { TemplatesService } from './services/template/TemplatesService'; 
import { AssessmentsService } from './services/assessment/AssessmentsService';
import { ClientsService } from './services/client/ClientsService';  
import { RatersService } from './services/rater/RatersService';
import { RaterTypesForModalComponent } from './coach/c-rater-types/rater-types-for-modal/rater-types-for-modal.component'; 
import { ClientProfileComponent } from './client/profile/profile.component';
import { LogComponent } from './admin/log/log.component';
import { NgProgressModule } from 'ngx-progressbar';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http'
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EditClientComponent } from './coach/edit-client/edit-client.component';
import { RatersModalComponent } from './coach/raters-modal/raters-modal.component';
import { ReminderEmailModalComponent } from './coach/reminder-email-modal/reminder-email-modal.component'
import { ResetPasswordComponent } from 'reset-password/reset-password.component';
import { AssessmentErrorPageComponent } from 'assessment-error-page/assessment-error-page.component';
import { CryptoJs } from './shared/crypto-js/crypto-js.component';
import { TabsComponent } from './coach/tabs/tabs.component';
import { LoggedOutPageComponent } from 'logged-out-page/logged-out-page.component';
//import { Translation } from './services/angular/Translation';
//import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { NgIdleModule } from '@ng-idle/core';

import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting
import { UserLoggedInService } from './services/angular/UserLoggedIn';
import { AssignAssessmentModalComponent } from './assign-assessment-modal/assign-assessment-modal.component';
import { TutorialComponent } from './coach/tutorial/tutorial.component';
import { UsersComponent } from './admin/users/users.component';
import { SsoComponent } from 'sso/sso.component';
import { AppPasswordDirective } from './shared/logginPassword/app-password.directive';
//import { BreadcrumbModule } from 'angular-crumbs';
import { PasswordStrengthComponent } from './shared/password-strength/password-strength.component';
import { AssessmentsModlllComponent } from './coach/assessments-mod-lll/assessments-mod-lll.component';

// Interceptors
import { HttpErrorInterceptor } from './services/angular/400.interceptor'; 

//import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { Ng9PasswordStrengthBarModule } from 'ng9-password-strength-bar';
import { AdminDasboardComponent } from './admin/admin-dasboard/admin-dasboard.component';
import { UserPersonalDataComponent } from './admin/user-personal-data/user-personal-data.component';
import { ArchivedAssessmentsComponent } from './coach/archived-assessments/archived-assessments.component';
import { AccessibleSelfAssessmentComponent } from 'accessible-self-assessment/accessible-self-assessment.component';

import { ActiveClientsComponent } from './coach/active-clients/active-clients.component';
import { ArchivedClientsComponent } from './coach/archived-clients/archived-clients.component';
import { QuillModule } from 'ngx-quill';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { CheckResetPasswordCodeResolverService } from './../reset-password/resolver/check-reset-password-code-resolver.service'
import { RaterLoginComponent } from './rater-login/rater-login.component';
import { UserCoachesListComponent } from './admin/user-coaches-list/user-coaches-list.component';
import { Ng2DropdownModule } from '@vpetrusevici/ng2-material-dropdown'; 
import { ChangeEnvironmentComponent } from './change-environment/change-environment.component';
import { ChangeEnvironmentResolverService } from './change-environment/resolver/change-environment-resolver.service';
import { DuplicateUsersComponent } from './admin/duplicate-users/duplicate-users.component';
import { AssessmentsModIComponent } from './admin/assessments-mod-i/assessments-mod-i.component';
import { ELIAPIService } from './services/eliapi/ELIAPIService';


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

declare global{
  interface Navigator{
    msSaveBlob:(blob: Blob,fileName:string) => boolean
  }
} 

@NgModule({
  declarations: [		
    AppComponent,
    HomeComponent,
    UserComponent,
    TablesComponent,
    TypographyComponent,
    IconsComponent,
    MapsComponent,
    NotificationsComponent,
    UpgradeComponent,
    NichesComponent,
    QuestionsComponent,
    RegularComponent,
    SatisfactionComponent,
    SurveyComponent,
    AssessmentsComponent,
    HelpComponent,
    NewRegularModalComponent,
    NewNicheModalComponent,
    UnassignedAssessmentsComponent,
    PurchaseAssessmentModalComponent,
    ClientReportsComponent,
    ClientAssessmentsComponent,
    InstructionsComponent,
    AssessmentsQuestionsComponent,
    RaterAssessmentInstructionsComponent,
    RaterAssessmentComponent,
    PendingAssessmentsComponent,
    CompletedAssessmentsComponent,
    CoachAssessmentsComponent,
    RatersComponent,
    AssignAssesmentsModalComponent,
    EmailTemplatesComponent,
    NewEmailTemplateComponent,
    PredefinedEmailTemplatesComponent,
    EmailTemplateComponent,
    AssessmentEliComponent,
    Assessment360Component,
    NewEliAssessmentComponent,
    New360AssessmentComponent,
    DataVisualizerComponent,
    BiDashboardComponent,
    NewSatisfactionModalComponent,
    NewSurveyModalComponent,
    Section1Component,
    Section2Component,
    NewSection1ModalComponent,
    NewSection2ModalComponent,
    CustomComponent,
    ProfileComponent,
    AssignedComponent,
    ClientsComponent,
    CoachCompletedAssessmentsComponent,
    AssignedRatersComponent,
    CoachDirectoryComponent,
    LoginComponent,
    DashboardComponent,
    DataVisualizerResultsComponent,
    EnergyLeadershipComponent,
    AssessmentReportComponent,
    CoachAssessmentReportComponent,
    AssessmentReport360Component,
    AssignAssesmentsNewModalComponent,
    PipeReplaceSpaces,
    NewRegularChoiceModalComponent,
    NewSatisfactionChoiceModalComponent,
    AssignedAssessmentComponent,
    ClientComponent,
    AccountActivationComponent,
    NewEmailTemplateComponentCopy1,
    CoachEmailsComponent,
    NewCoachEmailTemplateComponent,
    RaterAssessmentsComponent,
    AssessmentSectionsComponent,
    BusinessInteligenceComponent,
    Sections360Component,
    AssessmentComponent,
    RaterTakeAssessmentComponent,
    UserMenuComponent,
    CoachDashboardComponent,
    RaterTypesComponent,
    CRaterTypesComponent,
    CoachHomeComponent,
    AnnouncementsComponent,
    AssessmentDetailsComponent,
    ExpiredComponent,
    RaterTypesForModalComponent,
    ClientProfileComponent,
    LogComponent,
    EditClientComponent,
    RatersModalComponent,
    ResetPasswordComponent,
    AssessmentErrorPageComponent,
    TabsComponent,
    LoggedOutPageComponent,
    AssignAssessmentModalComponent,
    TutorialComponent,
    UsersComponent,
    SsoComponent,
    AppPasswordDirective,
    PasswordStrengthComponent,
    AssessmentsModlllComponent,
    AdminDasboardComponent,
    UserPersonalDataComponent,
    ArchivedAssessmentsComponent,
    ReminderEmailModalComponent,
    ActiveClientsComponent,
    ArchivedClientsComponent,
    RaterLoginComponent,
    UserCoachesListComponent,
    AccessibleSelfAssessmentComponent,
      ChangeEnvironmentComponent,
      DuplicateUsersComponent,
      AssessmentsModIComponent
   ],
    imports: [
    BrowserModule,
    FormsModule,
    NavbarModule,
    FooterModule,
    SidebarModule,
    RouterModule,
    AppRoutingModule,
    LbdModule,
    ModalModule.forRoot(),
    TabsModule,
    AngularDraggableModule,
    // AngularDateTimePickerModule, 
    ChartsModule,
    ImageUploadModule.forRoot(), 
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-full-width', preventDuplicates: true }),
    AgGridModule.withComponents([]),
    ReactiveFormsModule,
    QuillModule.forRoot(),
    KonvaModule,
    NgxGraphModule,
    NgxChartsModule,
    PopoverModule,
    TagInputModule,
    NgProgressModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    NgIdleModule.forRoot(),
    MomentModule,
    Ng9PasswordStrengthBarModule,
    Ng2DropdownModule
    //PasswordStrengthMeterModule
    //BreadcrumbModule
  ],
  providers: [
      Globals,
      AuthGuardService,
      AdminGuardService,
      CoachGuardService,
      ClientGuardService,
      RaterGuardService,
      AssessmentRefreshGuardService,
      PreviousRouteService,
      AssessmentsService,
      AdminService,
      CoachService,
      TemplatesService,
      ClientsService,
      RatersService,
      CheckResetPasswordCodeResolverService,
      ChangeEnvironmentResolverService,
      CryptoJs,
      UserLoggedInService,
      {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpErrorInterceptor,
          multi: true
      },
      TabsetConfig,
      ELIAPIService
      //Translation

    ],
  exports: [TranslateModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
